import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { TemplateTypeSelection } from "features/templates/components";
import { TEMPLATE_TYPES } from "features/templates/constants";
import type { TemplateType } from "features/templates/types";

import { Button } from "common/components/ui/Button";
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from "common/components/ui/Dialog";
import {
  Drawer,
  DrawerContent,
  DrawerTitle,
} from "common/components/ui/Drawer";
import { trackMetaPixel, typedObjectKeys } from "common/helpers/utils";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

const META_PIXEL_EVENT: Record<TemplateType, string> = {
  NOTE_TEMPLATE: "ConnectionNote",
  MESSAGE_TEMPLATE: "DirectMessage",
  INMAIL_TEMPLATE: "InMail",
  VOICE_TEMPLATE: "Voice",
};

export default function SelectTemplateType({
  isOpen,
  setIsOpen,
  initialTemplateType,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  initialTemplateType: TemplateType;
}) {
  const { search } = useLocation();
  const navigate = useNavigate();
  const isDesktop = useTwBreakpoint("lg");
  const [templateType, setTemplateType] =
    useState<TemplateType>(initialTemplateType);

  useEffect(() => {
    setTemplateType(initialTemplateType);
  }, [initialTemplateType]);

  function reset() {
    setTemplateType(initialTemplateType);
  }

  const Component = isDesktop ? Dialog : Drawer;
  const Content = isDesktop ? DialogContent : DrawerContent;
  const Title = isDesktop ? DialogTitle : DrawerTitle;

  return (
    <Component open={isOpen} onOpenChange={setIsOpen} onAfterClose={reset}>
      <Content>
        <Title className="mb-8">Choose template type</Title>

        <TemplateTypeSelection
          templateType={templateType}
          setTemplateType={setTemplateType}
          allowedTypes={typedObjectKeys(TEMPLATE_TYPES)}
        />

        <Button
          className="mt-8 ml-auto"
          onClick={() => {
            trackMetaPixel("trackCustom", META_PIXEL_EVENT[templateType]);
            setIsOpen(false);
            navigate({
              pathname: `../new/${templateType.toLowerCase()}`,
              search,
            });
          }}
        >
          Next
        </Button>
      </Content>
    </Component>
  );
}
